import Glide from '@glidejs/glide'

export const initProjectGallerySlide = () => {
  new Glide('[data-project-gallery-slide]', {
    autoplay: 3000
  }).mount()
}